<!-- ===============================
     HOME PAGE VIJP
=================================== -->

<div class="w-full font-sans text-gray-800">

    <!-- HERO SECTION -->
    <section id="home" class="relative w-full min-h-[70vh] md:h-[70vh] bg-cover bg-center"
        style="background-image: url('assets/img/homepageimg/anhbia.jpg');"
        role="region" aria-label="Hero - VIJP">

        <!-- dark overlay -->
        <div class="absolute inset-0 bg-gradient-to-b from-black/40 to-black/10"></div>

        <!-- decorative logo on right (show on all screens, nhỏ hơn trên mobile) -->
        <div data-aos="fade-left" data-aos-delay="200"
            class="absolute top-8 right-8 sm:right-10 md:right-12 z-30 pointer-events-none">
            <img src="assets/img/logo/logo.png" alt="VIJP Logo"
                class="w-32 sm:w-40 md:w-48 lg:w-96 xl:w-96 max-w-none" />
        </div>


        <!-- MAIN CONTENT -->
        <div
            class="relative z-30 w-full flex items-start md:items-center pt-20 pb-6 md:pt-0 md:h-[70vh] pl-4 sm:pl-6 md:pl-16 lg:pl-48">

            <div class="w-full md:w-7/12 lg:w-6/12">
                <h1 class="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight drop-shadow-lg"
                    data-aos="fade-right" data-aos-delay="200">
                    日本信発国際株式会社 - VIJP
                </h1>

                <p class="mt-4 text-base sm:text-lg text-white/90 tracking-wide" data-aos="fade-right"
                    data-aos-delay="300">
                    信頼を礎に、未来を発し、世界へつなぐ<br />
                    <span class="text-white/80">
                        Rooted in Trust. Creating the Future. Connecting to the World
                    </span>
                </p>

                <div class="mt-6 flex items-center gap-4" data-aos="fade-up" data-aos-delay="400">
                    <button (click)="scrollToContact()"
                        class="inline-flex items-center justify-center px-6 py-3 rounded-full bg-[#C8102E] hover:bg-[#a50d25] text-white font-semibold text-sm md:text-base shadow-lg transition transform hover:scale-[1.03]"
                        aria-label="Contact us">
                        CONTACT US
                    </button>
                </div>
            </div>
        </div>

        <!-- LICENSE BLOCK -->
        <div data-aos="fade-left" data-aos-delay="200"
            class="z-20 w-full px-4 sm:px-6 mt-20 md:mt-0 md:w-auto md:px-0 md:absolute md:bottom-6 md:right-6">
            <div class="text-white text-[11px] sm:text-xs md:text-sm px-4 py-3 rounded-lg shadow-lg max-w-md sm:max-w-lg md:max-w-xl mx-auto md:mx-0 bg-white/10 backdrop-blur-sm border border-white/10"
                style="line-height:1.4;">
                <div class="grid gap-x-4 gap-y-1" style="grid-template-columns: auto auto minmax(120px, 1fr);">

                    <!-- row 1 -->
                    <div class="whitespace-nowrap">宅地建物取引業</div>
                    <div class="whitespace-nowrap">免許証番号</div>
                    <div>東京都知事（１）第１０９６２７号</div>

                    <!-- row 2 -->
                    <div class="whitespace-nowrap">有料職業紹介事業</div>
                    <div class="whitespace-nowrap">許可番号</div>
                    <div>１３ーユー３１２５２７</div>

                    <!-- row 3 -->
                    <div class="whitespace-nowrap">労働者派遣事業</div>
                    <div class="whitespace-nowrap">許可番号</div>
                    <div>派１３－３１７６９６</div>

                    <!-- row 4 -->
                    <div class="whitespace-nowrap">電気通信媒介等</div>
                    <div class="whitespace-nowrap">届出番号</div>
                    <div>C２１０４４６８</div>
                </div>
            </div>
        </div>
    </section>




    <!-- SERVICE SECTION -->
    <section id="about" class="py-16 bg-white" data-aos="fade-up" data-aos-duration="600">
        <div class="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch">

            <!-- LEFT PANEL -->
            <div data-aos="fade-right" data-aos-delay="200" data-aos-duration="1000"
                class="relative bg-gradient-to-br from-[#C8102E] to-[#F4A300] rounded-2xl text-white p-8 flex flex-col justify-between shadow-lg">
                <div>
                    <!-- Title -->
                    <h2 class="text-2xl md:text-3xl font-bold leading-tight">
                        会社案内
                    </h2>

                    <!-- Subtitle -->
                    <p class="text-sm text-white/85 tracking-wide">
                        About Us
                    </p>
                    <p class="text-base leading-relaxed opacity-90">
                        VIJPは母会社のベトナム「Tín Phát」の傘下企業であり、日本での留学生支援、不動産、生活サポートを専門としています。
                    </p>
                    <p class="mt-3 text-sm opacity-90">
                        VIJP is a member of Tin Phat Group, providing comprehensive support for students, real estate,
                        jobs, and lifestyle services in Japan.
                    </p>
                </div>
                <button mat-flat-button
                    class="mt-8 bg-white text-[#C8102E] hover:bg-gray-100 font-semibold px-5 py-2 rounded-md self-start transition-transform transform hover:scale-105"
                    routerLink="/services">
                    View All Services
                </button>
            </div>

            <!-- RIGHT GRID -->
            <div data-aos="fade-left" data-aos-delay="300" data-aos-duration="1000"
                class="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-8">

                <!-- CARD TEMPLATE -->
                <div class="flex bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all group">
                    <div class="w-2/5 sm:w-full relative overflow-hidden">
                        <img src="assets/img/homepageimg/studensupport.JPEG"
                            alt="Student Support"
                            class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500">
                    </div>
                    <div class="w-3/5 p-5 flex flex-col justify-center">
                        <h3 class="text-lg font-semibold text-[#C8102E] mb-2">留学生支援事業</h3>
                        <p class="text-sm text-gray-700 leading-relaxed">
                            <span class="text-[#F4A300] font-medium">Student Support Business</span>
                        </p>
                    </div>
                </div>

                <div class="flex bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all group">
                    <div class="w-2/5 relative overflow-hidden">
                        <img src="assets/img/homepageimg/realestate.JPEG"
                            alt="Real Estate"
                            class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500">
                    </div>
                    <div class="w-3/5 p-5 flex flex-col justify-center">
                        <h3 class="text-lg font-semibold text-[#C8102E] mb-2">不動産事業</h3>
                        <p class="text-sm text-gray-700 leading-relaxed">
                            <span class="text-[#F4A300] font-medium">Real Estate Business</span>
                        </p>
                    </div>
                </div>

                <div class="flex bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all group">
                    <div class="w-2/5 relative overflow-hidden">
                        <img src="assets/img/homepageimg/recruitment.JPEG" alt="Jobs"
                            class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500">
                    </div>
                    <div class="w-3/5 p-5 flex flex-col justify-center">
                        <h3 class="text-lg font-semibold text-[#C8102E] mb-2">人材紹介事業</h3>
                        <p class="text-sm text-gray-700 leading-relaxed">
                            <span class="text-[#F4A300] font-medium">Recruitment Services</span>
                        </p>
                    </div>
                </div>

                <div class="flex bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all group">
                    <div class="w-2/5 relative overflow-hidden">
                        <img src="assets/img/homepageimg/telecommunication.JPEG"
                            alt="SIM & Lifestyle"
                            class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500">
                    </div>
                    <div class="w-3/5 p-5 flex flex-col justify-center">
                        <h3 class="text-lg font-semibold text-[#C8102E] mb-2">通信関係及び生活支援事業</h3>
                        <p class="text-sm text-gray-700 leading-relaxed">
                            <span class="text-[#F4A300] font-medium">Telecommunication and Lifestyle Support
                                Services</span>
                        </p>
                    </div>
                </div>

            </div>
        </div>
    </section>

    <!-- ABOUT US SECTION -->
    <section class="relative py-24 px-6 bg-[#FFF8F5] overflow-hidden" id="about" data-aos="fade-up" data-aos-duration="1000">
        <div class="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
            <div class="md:col-span-2" data-aos="fade-right" data-aos-delay="200">
                <h2 class="text-4xl md:text-5xl font-bold text-[#C8102E] mb-3">会社概要</h2>
                <h3 class="text-[#C8102E]/80 text-lg mb-6 tracking-wide">Company Profile</h3>

                <p class="text-gray-700 leading-relaxed text-base md:text-lg">
                    日本信発国際㈱は、お客様からの信頼を最も大切な価値とし、その信頼を基盤に新しい未来を創造し、
                    日本と世界をつなぐ架け橋となることを使命とします。<br />
                    　私たちは、誠実さをもって社会に貢献し、豊かな国際社会の発展に寄与する企業であり続けます。
                    すべてのステークホルダーと共に成長し、信頼の輪を世界へ広げてまいります。
                </p>
            </div>
            <!-- LEFT CONTENT -->
            <div data-aos="fade-right" data-aos-delay="200">

                <!-- Company Profile / 会社情報 -->
                <div class="bg-white rounded-2xl shadow-md border border-gray-100 p-6 md:p-8 
            relative before:absolute before:left-0 before:top-0 before:h-full 
            before:w-[4px] before:bg-[#C8102E] before:rounded-l-2xl">

                    <dl class="space-y-3 text-sm md:text-base">
                        <!-- Company Name -->
                        <div class="grid grid-cols-1 sm:grid-cols-4 gap-2">
                            <dt class="sm:col-span-4 font-medium text-red-600 text-2xl">
                                会社理念
                            </dt>
                        </div>

                        <div class="grid grid-cols-1 sm:grid-cols-1 gap-2 mb-12">
                            <dt class="sm:col-span-4 font-medium">
                                弊社、ベトナムに本社を置く TIN PHAT GROUP を母体とし、<br>
                                同グループの日本法人として設立されました。<br>
                                <br>
                                ベトナム本社と連携し、アジアと日本をつなぐ架け橋として、<br>
                                より質の高いサービスの提供と国際的な価値創出に取り組んでいます。<br>
                                グループ全体の豊富な経験とネットワークを活かし、<br>
                                お客様に安心と信頼をお届けいたします。<br>
                            </dt>
                        </div>


                        <!-- Company Name -->
                        <div class="grid grid-cols-1 sm:grid-cols-4 gap-2">
                            <dt class="sm:col-span-4 text-red-600  mt-6 text-2xl">
                                会社概要
                            </dt>
                        </div>
                        <div class="grid grid-cols-1 sm:grid-cols-4 gap-2">
                            <dt class="sm:col-span-1 font-medium text-gray-500">
                                会社名
                            </dt>
                            <dd class="sm:col-span-3">
                                <p>
                                    日本信発国際株式会社（VIJP Co., Ltd）
                                </p>
                            </dd>
                        </div>

                        <!-- Representative -->
                        <div class="grid grid-cols-1 sm:grid-cols-4 gap-2">
                            <dt class="sm:col-span-1 font-medium text-gray-500">
                                代表
                            </dt>
                            <dd class="sm:col-span-3">
                                <p>
                                    代表取締役　グエン カック ルン
                                </p>
                            </dd>

                        </div>

                        <!-- Address -->
                        <div class="grid grid-cols-1 sm:grid-cols-4 gap-2">
                            <dt class="sm:col-span-1 font-medium text-gray-500">
                                所在地
                            </dt>
                            <dd class="sm:col-span-3 text-gray-800 space-y-2">

                                <p>
                                    <span class="font-semibold">【本社】</span><br>
                                    〒116-0013 東京都荒川区西日暮里5-2-19 リントン第2西日暮里2F<br>
                                    TEL: 03-5850-5775　FAX: 03-5850-5776
                                </p>

                                <p>
                                    <span class="font-semibold">【福岡支社】</span><br>
                                    〒812-0007 福岡県福岡市博多区東比恵2-17-23ローズマンション第一博多1号館 311号<br>
                                    TEL: 092-402-1741　FAX: 092-402-1742

                                </p>

                                <p>
                                    <span class="font-semibold">【熊本支社】</span><br>
                                    〒869-1101 熊本県菊池郡菊陽町津久礼1977-46コーポ青葉台 203号<br>
                                    TEL: 096-234-9676　FAX: 096-234-9677

                                </p>

                                <p>
                                    <span class="font-semibold">【ベトナム母体会社】</span><br>
                                    TIN PHAT GROUP<br>
                                    14F Sunsquare, Le Duc Tho, My Dinh, Ha Noi, Vietnam
                                </p>

                            </dd>
                        </div>

                        <!-- Established -->
                        <div class="grid grid-cols-1 sm:grid-cols-4 gap-2">
                            <dt class="sm:col-span-1 font-medium text-gray-500">設立</dt>
                            <dd class="sm:col-span-3 text-gray-800">2020年01月15日</dd>
                        </div>

                        <!-- Capital -->
                        <div class="grid grid-cols-1 sm:grid-cols-4 gap-2">
                            <dt class="sm:col-span-1 font-medium text-gray-500">資本金</dt>
                            <dd class="sm:col-span-3 text-gray-800">2,500万円</dd>
                        </div>

                        <!-- Banks -->
                        <div class="grid grid-cols-1 sm:grid-cols-4 gap-2">
                            <dt class="sm:col-span-1 font-medium text-gray-500">取引銀行</dt>
                            <dd class="sm:col-span-3 text-gray-800">
                                三菱UFJ銀行 ／ 三井住友銀行
                            </dd>
                        </div>

                        <!-- Clients -->
                        <div class="grid grid-cols-1 sm:grid-cols-4 gap-2">
                            <dt class="sm:col-span-1 font-medium text-gray-500">主な取引先</dt>
                            <dd class="sm:col-span-3 text-gray-800 space-y-1">
                                <p>ZENSHO GROUP、すかいらーくグループ、日高屋、くら寿司</p>
                                <p>株式会社レオパレス21</p>
                                <p>株式会社ハウゼスタッフ</p>
                                <p>株式会社マスミフードサービス</p>
                                <p>日本国内　監理団体　日本語学校　多数</p>
                                <p>海外　大学　短期大学　日本語学校　多数</p>
                            </dd>
                        </div>

                        <!-- Business Fields -->
                        <div class="grid grid-cols-1 sm:grid-cols-4 gap-2">
                            <dt class="sm:col-span-1 font-medium text-gray-500">事業内容</dt>
                            <dd class="sm:col-span-3 text-gray-800 space-y-1">
                                <p>留学生支援事業</p>
                                <p>不動産事業</p>
                                <p>人材紹介事業</p>
                                <p>通信関係及び生活支援事業</p>
                            </dd>
                        </div>

                    </dl>
                </div>

                <button mat-flat-button color="warn"
                    class="mt-8 bg-[#C8102E] hover:bg-[#a50d25] text-white font-semibold px-8 py-3 rounded-lg text-base shadow-lg transition-transform transform hover:scale-105"
                    routerLink="/about">
                    READ MORE / 詳しく見る
                </button>
            </div>


            <!-- RIGHT IMAGES -->
            <div class="relative grid grid-cols-2 gap-4" data-aos="fade-left" data-aos-delay="300">
                <!-- Left Column (2 images) -->
                <div class="space-y-4">
                    <!-- Image 1 -->
                    <div class="relative rounded-2xl overflow-hidden shadow-lg group">
                        <img src="assets/img/homepageimg/hp1.jpg" alt="Office"
                            class="w-full h-60 object-cover transition-transform duration-700 group-hover:scale-110" />
                        <div
                            class="absolute inset-0 bg-[#C8102E]/30 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center text-white text-sm font-semibold">
                            Office / オフィス
                        </div>
                    </div>

                    <!-- Image 2 -->
                    <div class="relative rounded-2xl overflow-hidden shadow-lg group">
                        <img src="assets/img/homepageimg/hp2.PNG" alt="Meeting"
                            class="w-full h-60 object-cover transition-transform duration-700 group-hover:scale-110" />
                        <div
                            class="absolute inset-0 bg-[#F4A300]/30 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center text-white text-sm font-semibold">
                            Meeting / ミーティング
                        </div>
                    </div>
                </div>

                <!-- Right Column (2 images) - lowered for staggered effect -->
                <div class="space-y-4 mt-10 md:mt-12">
                    <!-- Image 3 -->
                    <div class="relative rounded-2xl overflow-hidden shadow-lg group">
                        <img src="assets/img/homepageimg/hp3.jpg" alt="Team"
                            class="w-full h-60 object-cover transition-transform duration-700 group-hover:scale-110" />
                        <div
                            class="absolute inset-0 bg-[#C8102E]/30 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center text-white text-sm font-semibold">
                            Team / チーム
                        </div>
                    </div>

                    <!-- Image 4 -->
                    <div class="relative rounded-2xl overflow-hidden shadow-lg group">
                        <img src="assets/img/homepageimg/hp4.jpg"
                            alt="Collaboration"
                            class="w-full h-60 object-cover transition-transform duration-700 group-hover:scale-110" />
                        <div
                            class="absolute inset-0 bg-[#F4A300]/30 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center text-white text-sm font-semibold">
                            Collaboration / 協力
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>



    <!-- SERVICES SECTION -->
    <section id="services" class="py-24 bg-white" data-aos="fade-up" data-aos-duration="800" data-aos-once="true">
        <div class="max-w-5xl mx-auto px-6">

            <!-- TITLE -->
            <div class="text-center mb-12">
                <h2 class="text-4xl font-bold text-[#C8102E] mb-2" data-aos="fade-down" data-aos-delay="100">
                    事業内容
                </h2>
                <h3 class="text-[#C8102E]/80 text-lg tracking-wide" data-aos="fade-down" data-aos-delay="200">
                    Services
                </h3>
            </div>

            <!-- LIST (4 CARD THẲNG DỌC) -->
            <div class="space-y-8">

                <!-- CARD 1 -->
                <div id="card1"
                    class="group bg-[#FFF8F5] rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-500"
                    data-aos="fade-up" data-aos-delay="100">
                    <div class="md:flex md:items-stretch">

                        <!-- IMAGE -->
                        <div class="md:w-1/3 relative overflow-hidden">
                            <img src="assets/img/homepageimg/studensupport.JPEG"
                                alt="Student Support"
                                class="w-full sm:h-full md:h-full object-cover transform group-hover:scale-105 transition-transform duration-700 ease-out" />
                            <div
                                class="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                            </div>
                        </div>

                        <!-- CONTENT -->
                        <div class="md:w-2/3 p-6 md:p-8 text-left flex flex-col justify-center">
                            <h4 class="text-[#C8102E] font-semibold text-xl mb-1">留学生支援事業</h4>
                            <p class="text-[#C8102E]/70 mb-3 text-sm md:text-base">Student Support Business</p>
                            <p class="text-gray-600 text-sm md:text-base leading-relaxed">
                                空港送迎、在留手続き、SIM登録、住居・アルバイト支援など、留学生生活を全面サポート。
                            </p>
                            <p class="text-gray-500 text-sm mt-2">
                                Comprehensive support for Vietnamese students in Japan — from airport pickup to housing
                                and daily life.
                            </p>
                        </div>
                    </div>
                </div>

                <!-- CARD 2 -->
                <div id="card2"
                    class="group bg-[#FFF8F5] rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-500"
                    data-aos="fade-up" data-aos-delay="150">
                    <div class="md:flex md:items-stretch">

                        <!-- IMAGE -->
                        <div class="md:w-1/3 relative overflow-hidden">
                            <img src="assets/img/homepageimg/realestate.JPEG"
                                alt="Real Estate"
                                class="w-full sm:h-full md:h-full object-cover transform group-hover:scale-105 transition-transform duration-700 ease-out" />
                            <div
                                class="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                            </div>
                        </div>

                        <!-- CONTENT -->
                        <div class="md:w-2/3 p-6 md:p-8 text-left flex flex-col justify-center">
                            <h4 class="text-[#C8102E] font-semibold text-xl mb-1">不動産事業</h4>
                            <p class="text-[#C8102E]/70 mb-3 text-sm md:text-base">Real Estate Business</p>
                            <p class="text-gray-600 text-sm md:text-base leading-relaxed">
                                信頼できる日本の不動産会社と提携し、賃貸物件や学生寮を紹介・契約・管理。
                            </p>
                            <p class="text-gray-500 text-sm mt-2">
                                Introducing and managing apartments, dormitories, and housing in partnership with
                                trusted Japanese real estate firms.
                            </p>
                        </div>
                    </div>
                </div>

                <!-- CARD 3 -->
                <div id="card3"
                    class="group bg-[#FFF8F5] rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-500"
                    data-aos="fade-up" data-aos-delay="200">
                    <div class="md:flex md:items-stretch">

                        <!-- IMAGE -->
                        <div class="md:w-1/3 relative overflow-hidden">
                            <img src="assets/img/homepageimg/recruitment.JPEG"
                                alt="Recruitment"
                                class="w-full sm:h-full md:h-full object-cover transform group-hover:scale-105 transition-transform duration-700 ease-out" />
                            <div
                                class="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                            </div>
                        </div>

                        <!-- CONTENT -->
                        <div class="md:w-2/3 p-6 md:p-8 text-left flex flex-col justify-center">
                            <h4 class="text-[#C8102E] font-semibold text-xl mb-1">人材紹介事業</h4>
                            <p class="text-[#C8102E]/70 mb-3 text-sm md:text-base">Recruitment Services</p>
                            <p class="text-gray-600 text-sm md:text-base leading-relaxed">
                                学生の能力・時間に合わせたアルバイト紹介。面接や契約時の通訳サポート付き。
                            </p>
                            <p class="text-gray-500 text-sm mt-2">
                                Part-time job matching for students based on ability, schedule, and desired field — with
                                interpreter support.
                            </p>
                        </div>
                    </div>
                </div>

                <!-- CARD 4 -->
                <div id="card4"
                    class="group bg-[#FFF8F5] rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-500"
                    data-aos="fade-up" data-aos-delay="250">
                    <div class="md:flex md:items-stretch">

                        <!-- IMAGE -->
                        <div class="md:w-1/3 relative overflow-hidden">
                            <img src="assets/img/homepageimg/telecommunication.JPEG"
                                alt="Telecommunication & Lifestyle"
                                class="w-full sm:h-full md:h-full object-cover transform group-hover:scale-105 transition-transform duration-700 ease-out" />
                            <div
                                class="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                            </div>
                        </div>

                        <!-- CONTENT -->
                        <div class="md:w-2/3 p-6 md:p-8 text-left flex flex-col justify-center">
                            <h4 class="text-[#C8102E] font-semibold text-xl mb-1">通信関係及び生活支援事業</h4>
                            <p class="text-[#C8102E]/70 mb-3 text-sm md:text-base">
                                Telecommunication and Lifestyle Support Services
                            </p>
                            <p class="text-gray-600 text-sm md:text-base leading-relaxed">
                                SIM登録、インターネット、銀行口座開設、行政手続きなど、日本生活を支援します。
                            </p>
                            <p class="text-gray-500 text-sm mt-2">
                                SIM card setup, internet, bank account, and lifestyle assistance — everything students
                                need for life in Japan.
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>

    <!-- CONTACT SECTION -->
    <section id="contact" class="bg-[#FFF8F5] py-20 relative" data-aos="fade-up" data-aos-duration="300">
        <div class="max-w-4xl mx-auto px-6 text-center py-20 ">
            <!-- TITLE -->
            <h2 class="text-4xl md:text-3xl font-bold text-[#C8102E] uppercase">
                お問い合わせフォーム
            </h2>
            <p class="text-[#C8102E] text-xl font-medium mb-8">
                CONTACT US
            </p>

            <!-- DESCRIPTION -->
            <p class="max-w-2xl mx-auto text-gray-600 mb-10 text-base leading-relaxed">
                下記のフォームに必要事項をご記入の上、送信してください。<br />
                Please fill out the form below and our team will get back to you soon.
            </p>

            <!-- CONTACT FORM -->
            <form [formGroup]="inquiryForm" (ngSubmit)="onSubmitInquiryForm()"
                class="bg-white rounded-2xl shadow-lg border border-[#F4A300]/30 p-8 grid grid-cols-1 md:grid-cols-2 gap-6 text-left">
                <!-- LEFT SIDE -->
                <div class="space-y-4">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>お名前 / Name</mat-label>
                        <input matInput formControlName="name" required />
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>メール / Email</mat-label>
                        <input matInput type="email" formControlName="email" required />
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>電話番号 / Phone Number</mat-label>
                        <input matInput formControlName="phone" />
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>お問い合わせ種類 / Inquiry Type</mat-label>
                        <mat-select formControlName="inquiryType">
                            <mat-option value="study">留学 / Study Abroad</mat-option>
                            <mat-option value="job">採用 / Recruitment</mat-option>
                            <mat-option value="partnership">協力 / Partnership</mat-option>
                            <mat-option value="other">その他 / Other</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- RIGHT SIDE -->
                <div class="space-y-4 flex flex-col justify-between">
                    <mat-form-field appearance="outline" class="w-full flex-1">
                        <mat-label>メッセージ / Message</mat-label>
                        <textarea matInput formControlName="message" rows="8"
                            placeholder="ご用件をご記入ください。/ Please write your message here..."></textarea>
                    </mat-form-field>


                </div>
                <div class="col-span-1 md:col-span-2 flex justify-center mt-4">
                    <button mat-flat-button color="warn" type="submit"
                        class="bg-[#C8102E] hover:bg-[#F4A300] text-white font-semibold py-3 px-10 rounded-md transition duration-300 shadow-md hover:shadow-lg">
                        送信する / SEND MESSAGE
                    </button>
                </div>
            </form>
        </div>
    </section>
</div>